import { render, staticRenderFns } from "./HeaderCreditor.vue?vue&type=template&id=564e8b95&scoped=true&"
import script from "./HeaderCreditor.vue?vue&type=script&lang=js&"
export * from "./HeaderCreditor.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCreditor.vue?vue&type=style&index=0&id=564e8b95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e8b95",
  null
  
)

export default component.exports